import React, { useState, useEffect, useCallback } from 'react';
import { Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CreditGauge({ collapsed = false }) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/credits/balance`, { withCredentials: true });
      setData(res.data);
    } catch (_) {}
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!data) return null;

  const { balance, monthly_credits, plan } = data;
  const pct = monthly_credits > 0 ? Math.min((balance / monthly_credits) * 100, 100) : (balance > 0 ? 100 : 0);
  const color = pct > 50 ? '#20c997' : pct > 20 ? '#ffd93d' : '#ff6b6b';

  if (collapsed) {
    return (
      <button
        onClick={() => navigate('/credits')}
        title={`${balance} crédits restants`}
        data-testid="credit-gauge-collapsed"
        className="flex flex-col items-center gap-1 text-[#64748b] hover:text-white transition-colors"
      >
        <Zap size={18} style={{ color }} />
        <span className="text-[10px] font-bold" style={{ color }}>{balance}</span>
      </button>
    );
  }

  return (
    <button
      onClick={() => navigate('/credits')}
      data-testid="credit-gauge"
      className="w-full bg-[#0f0e17] border border-[#2a2935] rounded-xl p-3 flex flex-col gap-2 relative overflow-hidden hover:border-[#3a3945] transition-colors text-left"
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-1.5">
          <Zap size={13} style={{ color }} />
          <span className="text-xs font-bold text-white">Crédits</span>
        </div>
        <span className="text-xs font-bold" style={{ color }}>{balance}</span>
      </div>
      <div className="h-1.5 w-full bg-[#2a2935] rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, background: `linear-gradient(90deg, #ffd93d, ${color})` }}
        />
      </div>
      {monthly_credits > 0 && (
        <p className="text-[10px] text-[#64748b]">
          {balance}/{monthly_credits} — {plan}
        </p>
      )}
    </button>
  );
}
